import React from "react";
import { FaEye } from "react-icons/fa";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { useData } from "../../context/DataContext";
import { resolveMediaUrl } from "../../utils/mediaUrl";

function ViewFoto({ foto }) {
  const { gambar } = useData();
  const src = resolveMediaUrl(`${gambar}perawatan/`, foto);

  if (!src) {
    return <span className="text-xs text-gray-400">-</span>;
  }

  return (
    <PhotoProvider>
      <PhotoView src={src}>
        <button
          type="button"
          className="p-2 text-blue-600 hover:bg-blue-100 rounded-lg transition-all duration-200 hover:scale-110"
          title="Lihat foto"
        >
          <FaEye className="w-4 h-4" />
        </button>
      </PhotoView>
    </PhotoProvider>
  );
}

export default ViewFoto;
